import Vue from "vue";
import VueHtml2Pdf from 'vue-html2pdf';
import Vue2TouchEvents from "vue2-touch-events";
import StudieInspiratorWidget from "./components/StudyInspirator.vue";
import Vuex from "vuex";
import {State} from "@/apps/StudyInspiratorWidget/models/store-state-model";
import actions from "@/apps/StudyInspiratorWidget/store/actions";
import getters from "@/apps/StudyInspiratorWidget/store/getters";
import mutations from "@/apps/StudyInspiratorWidget/store/mutations";
import {root} from "@/shared/store";

Vue.config.productionTip = false;

Vue.use(VueHtml2Pdf);
Vue.use(Vue2TouchEvents);

let widgets = document.querySelectorAll('widget-study-inspirator');
if (widgets.length) {
    widgets.forEach(el => {
        let store = new Vuex.Store({
            state: new State,
            actions: actions,
            getters: getters,
            mutations: mutations,
            modules: {
                root
            }
        });

        new Vue({
            el: el,
            store,
            render(h: any) {
                let info = this.$el.attributes.getNamedItem('info');
                let questions = this.$el.attributes.getNamedItem('questions');
                let labels = this.$el.attributes.getNamedItem('labels');

                return h(StudieInspiratorWidget, {
                    props: {
                        configRaw: {
                            model: info ? JSON.parse(info.value) : null,
                            questions: questions ? JSON.parse(questions.value) : null,
                            labels: labels ? JSON.parse(labels.value) : null
                        }
                    }
                });
            }
        });
    });
}
